import CommonService from "@/domain/dataTable/commonService/CommonService.js";
import { debug } from "util";
export default class NotificacoesServices extends CommonService {
    constructor(http) {
        super(http);
    }

    getNotificacoesGeral(id_user, id_empr, page, size) {
        // ?_page=1&_pagesize=10
        let pagina = page || 1;
        let qntidade = size || 10;
        let url = `notificacoes/geral/user/${id_user}/emp/${id_empr}?_page=${pagina}&_pagesize=${qntidade}`;
        return this._resource.get(url).then(success => {
            return success;
        },
            failed => {
                return failed;
            });
    }

    attVisto(idNotificacao, idUsuario) {
        let url = `notificacoes/geral`;
        let body = JSON.stringify({ usuario: idUsuario, notificacoes: idNotificacao });

        return this._resource.post(url, body).then(
            success => {
                return success;
            },
            failed => {
                return failed;
            }
        )
    }




}


// WEBPACK FOOTER //
// ./src/domain/notificacoes/NotificacoesService.js